import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose, IoArrowBack, IoArrowForward } from "react-icons/io5";
import serviceimg1 from "./Images/Serviceimg1.png";
import serviceimg2 from "./Images/Serviceimg2.png";
import serviceimg3 from "./Images/Serviceimg3.png";
import serviceimgroom from "./Images/Serviceimgroom.png";
import serviceimg4 from "./Images/Serviceimg4.png";
import serviceimg5 from "./Images/Serviceimg5.png";
// import serviceimg6 from "./Images/Serviceimg6.png";
import serviceimg7 from "./Images/Serviceimg7.png";

const TourModal = ({ topic, onClose }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const getServiceSteps = () => [
    {
      image: serviceimg1,
      title: "Open Boarding Service ",
      description:
        "Go to Service Management from the left menu and select Boarding Services to add and view the boarding services.",
      popupPosition: { top: "20%", left: "18%" },
    },
    {
      image: serviceimg2,
      title: "Click '+ Boarding service'",
      description: "Click + Boarding Service to create a new boarding service.",
      popupPosition: { top: "18%", right: "15%" }, // right side
    },
    {
      image: serviceimg3,
      title: "Fill Service Details",
      description:
        "Enter the service name, pet type, price, and other required details.",
      popupPosition: { top: "10%", left: "5%" }, // left, a bit lower
    },
    {
      image: serviceimgroom,
      title: "Add Room and Save",
      description:
        "Click Add Room if you need to add a new room. Enter the room details and click Save.",
      popupPosition: { top: "10%", left: "5%" }, // left, a bit lower
    },
    {
      image: serviceimg4,
      title: "Continue to Next Step",
      description:
        "After adding the required details, click Next to continue creating the boarding service.",
      popupPosition: { bottom: "2%", right: "22%" }, // bottom right
    },
    {
      image: serviceimg5,
      title: "Add Extra Charges",
      description:
        "Set any extra charges based on the pet's size  and room type, then click Next.",
      popupPosition: { top: "10%", left: "5%" }, // bottom right
    },
    // {
    //   image: serviceimg6,
    //   title: "Select Service inclusions and click on Next",
    //   description:
    //     "On this step, you can select the service inclusions that will be included with this service.",
    //   popupPosition: { top: "10%", left: "5%" }, // bottom right
    // },
    {
      image: serviceimg7,
      title: "Check and Save",
      description:
        "Check all the service details. If you need to make changes, click Previous, update the details, and then click Save.",
      popupPosition: { top: "10%", left: "5%" }, // bottom right
    },
  ];

  const steps = getServiceSteps();
  const totalSteps = steps.length;
  const current = steps[currentStep];

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSkip();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onClose();
    
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center">
      {/* Full-screen background image */}
      <div className="absolute inset-0">
        <img
          src={current.image}
          alt={`Step ${currentStep + 1}`}
          className="w-full h-full object-contain bg-black"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1920x1080?text=Tour+Image";
          }}
        />
      </div>

      {/* Global skip button (top right) - optional but handy */}
      <button
        onClick={handleSkip}
        className="absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors z-30 backdrop-blur-sm"
        aria-label="Skip tour"
      >
        <IoClose size={24} />
      </button>

      {/* Step indicator dots (bottom center) */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-30">
        {steps.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentStep(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentStep
                ? "bg-white w-4"
                : "bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>

      {/* Positioned popup for the current step */}
      <div className="absolute z-30" style={current.popupPosition}>
        <div className="bg-white rounded-xl shadow-2xl w-72 md:w-80 p-5 animate-fadeIn">
          {/* Step number */}
          <div className="flex justify-between items-center mb-3">
            <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
              Step {currentStep + 1} of {totalSteps}
            </span>
            <button
              onClick={handleSkip}
              className="text-xs text-gray-400 hover:text-gray-600"
            >
              Skip
            </button>
          </div>

          {/* Title & description */}
          <h3 className="text-lg font-bold text-gray-800 mb-2">
            {current.title}
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {current.description}
          </p>

          {/* Navigation buttons inside the popup */}
          <div className="flex justify-between items-center mt-5 pt-3 border-t border-gray-100">
            <button
              onClick={handleBack}
              disabled={currentStep === 0}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition ${
                currentStep === 0
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <IoArrowBack size={14} /> Back
            </button>
            <button
              onClick={handleNext}
              className="flex items-center gap-1 px-4 py-1.5 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition shadow-sm"
            >
              {currentStep === totalSteps - 1 ? "Finish" : "Next"}{" "}
              {currentStep !== totalSteps - 1 && <IoArrowForward size={14} />}
            </button>
          </div>
        </div>
      </div>

      {/* Optional: subtle animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default TourModal;
